import { gql } from "@apollo/client";
import { BagType, BagTaskLogOperateStatus } from "../types/ConsolidationTypes";

export const GET_BAG_TASK_LOG = gql`
    query GetBagTaskLog($id: Long!) {
        getBagTaskLog(id: $id) {
            id
            accountId
            destinationHubId
            destinationHubName
            destinationWhsId
            destinationWhsName
            startTime
            endTime
            bagType
            operateStatus
            creationHub
            createdAt
            updatedAt
        }
    }
`;

export interface GetBagTaskLogVariables {
    id: number;
}

export interface BagTaskLogType {
    id: number;
    accountId: number;
    destinationHubId?: number;
    destinationHubName?: string;
    destinationWhsId?: number;
    destinationWhsName?: string;
    startTime?: number;
    endTime?: number;
    bagType: BagType;
    operateStatus: BagTaskLogOperateStatus;
    creationHub?: number;
    createdAt?: number;
    updatedAt?: number;
}

export interface GetBagTaskLogResponse {
    getBagTaskLog: BagTaskLogType | null;
}
